import { formatMoney } from '../../../i18n/formatNumber';
import { localizeSystemText } from '../../../i18n/messages';
import React from "react";
import OfferDataPrices from "../../../data/OfferDataPrices";
import { useTranslation } from 'react-i18next';

function OfferPriceGrid() {
  const { t: tr, i18n } = useTranslation();
  return (
    <div>
      <div className="offer-price-cards">
      {OfferDataPrices.map(({ title, description, prices }) => (
        <div key={title} className="offer-price-item">
          <div className="offer-price-panel p-4 d-flex flex-column justify-content-center align-items-center">
            <div className="row flex-column align-items-center justify-content-center mb-3">
              <h3 className="offer-price-title text-center mb-1">{title === "Zajęcia indywidualne" ? tr("public:offerIndividual") : localizeSystemText(title, tr)}</h3>
              <p className="offer-price-description text-center mb-0">{localizeSystemText(description, tr)}</p>
            </div>
            <div className="row justify-content-center">
              {prices.map(({ duration, price }) => (
                <div key={`${title}-${duration}-${price}`} className="col-12 row justify-content-around m-0 p-0 mt-2">
                  <div className="offer-price-text p-0 col-6 d-flex justify-content-center">
                    {duration.replace(/ /g, "\u00A0")}
                  </div>
                  <div className="offer-price-text p-0 col-6 d-flex justify-content-center">
                    {formatMoney(parseFloat(price), i18n.language, { maximumFractionDigits: 0 })}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      ))}
      </div>
      <p className="offer-price-note col-12 text-center">{tr("public:pricesForClassesOf26PeopleArePerPerson_76")}</p>
      <p className="offer-price-note col-12 text-center">{tr("public:pricesAreInPolishZlotyAndIncludeAllStandard_77")}</p>
    </div>
  );
}

export default OfferPriceGrid;
